import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import '../element-variables.scss'
import './assets/style/main.scss'
import router from './router'
import store from './store'
import api from './http'
import './utils/dialog'

import _ from 'lodash'

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(api);

Vue.prototype._ = _

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app');
